import { Directive, OnDestroy } from '@angular/core';
import { LcsColumnDefDirective, LcsTableComponent } from '@lcs/shared/table';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[lcsColumnDef][autoRegister]',
    standalone: false
})
export class AutoRegisterColumnDefDirective implements OnDestroy {
   constructor(private table: LcsTableComponent<any>, private columnDef: LcsColumnDefDirective) {
      table.addColumnDef(columnDef as any);
   }

   ngOnDestroy(): void {
      this.table.removeColumnDef(this.columnDef as any);
   }
}
